
import React from "react";
import { Container, Grid, Typography, Box } from "@mui/material";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import logos from "../../assets/img/download.webp";


function ShowerQuickly() {
  const videos = [
    "https://www.youtube.com/embed/ZCLurXg0iuA?si=CKbOdtjiUIHQdb1O",
    "https://www.youtube.com/embed/b90cp2Ix4Yk?si=18Aw7jw9npE0RXCX",
    "https://www.youtube.com/embed/Aa6UDyVOhdQ?si=IbXdiLNu9nrQf8wO",
  ];

  return (
    <Box
      id="shower-quickly"
      sx={{
        backgroundColor: "#74325c", // Marrón mate
        color: "white",
        py: 8,
        minHeight: "85vh",
      }}
    >
      <Container maxWidth="md">
        <Typography
          variant="h4"
          component="h2"
          gutterBottom
          sx={{ fontFamily: "Montserrat, sans-serif", fontWeight: "bold", textAlign: "center" }}
        >
          Báñate en 5 minutos
        </Typography>
        <Grid container spacing={4}>
          {/* Columna izquierda (imagen) */}
          <Grid item xs={12} md={6}>
            <Box
              component="img"
              src={logos}
              alt="Báñate en 5 minutos"
              sx={{
                width: "100%",
                height: "auto",
                objectFit: "cover",
                borderRadius: "8px",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
              }}
            />
          </Grid>
          
          {/* Columna derecha (videos en Swiper) */}
          <Grid item xs={12} md={6}>
          <Swiper
            spaceBetween={10}
            slidesPerView={1}
            navigation
            pagination={{ clickable: true }}
            modules={[Pagination, Navigation]}  // 🔹 Agregar los módulos aquí
            >

              {videos.map((video, index) => (
                <SwiperSlide key={index}>
                  <iframe
                    width="100%"
                    height="400"
                    src={video}
                    title={`Video ${index + 1}`}
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerPolicy="strict-origin-when-cross-origin"
                    allowFullScreen
                    style={{ borderRadius: "8px", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)" }}
                  ></iframe>
                </SwiperSlide>
              ))}
            </Swiper>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default ShowerQuickly;